import { jsxs as f, jsx as t } from "react/jsx-runtime";
import { forwardRef as N, useState as S, useEffect as j } from "react";
import { c as v } from "./index-SYE1cn5_.js";
import { L as M } from "./Label-DMBnN1_E.js";
import { T as m } from "./Text-D6i4LEWL.js";
const b = "_field_w0m3c_1", y = "_textarea_w0m3c_8", z = "_counter_w0m3c_30", C = "_errorMessage_w0m3c_37", a = {
  field: b,
  textarea: y,
  counter: z,
  errorMessage: C
}, B = N(
  function({
    id: c,
    label: d,
    className: _,
    placeholder: x,
    value: e,
    required: o,
    resize: p = !1,
    maxLength: r,
    disabled: u,
    errorMessage: s,
    onChange: n,
    ...h
  }, T) {
    const [g, i] = S(e || "");
    j(() => {
      i(e || "");
    }, [e]);
    const w = (l) => {
      i(l.target.value), n && n(l);
    };
    return /* @__PURE__ */ f("div", { className: v(a.field, _), children: [
      /* @__PURE__ */ t(M, { htmlFor: c, required: o, children: d }),
      /* @__PURE__ */ t(
        "textarea",
        {
          id: c,
          ref: T,
          placeholder: x,
          className: a.textarea,
          required: o,
          "data-resize": p,
          maxLength: r,
          defaultValue: e,
          onChange: w,
          disabled: u,
          "data-error": !!s,
          ...h
        }
      ),
      /* @__PURE__ */ t("div", { className: a.counter, children: r && /* @__PURE__ */ f(m, { variant: "caption", children: [
        g.length.toString(),
        "/",
        r.toString(),
        " caracteres"
      ] }) }),
      s && /* @__PURE__ */ t(m, { variant: "caption", className: a.errorMessage, children: s })
    ] });
  }
);
export {
  B as T
};
